/* eslint-disable camelcase */
import common_en from "./en/common";
// eslint-disable-next-line
export default {
    en: {
        common: common_en,
    }
};
